import { render, staticRenderFns } from "./CriarEmailModal.vue?vue&type=template&id=1fdfb5eb&scoped=true"
import script from "./CriarEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarEmailModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarEmailModal.vue?vue&type=style&index=0&id=1fdfb5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdfb5eb",
  null
  
)

export default component.exports